import {formatString} from 'libs/utils/utils';

export const BTN_MY_PICKS_REMOVED_PRODUCT = 'my_picks_heart_removed_product';
export const BTN_LOGIN_SOCIAL_FACEBOOK = 'Login_Social_Login_Facebook';
export const BTN_LOGIN_SOCIAL_GOOGLE = 'Login_Social_Login_Google';

export const CATEGORY_PAGE = {
    EVENT_CATEGORY: 'mobile category page',
    ACTION: {FILTER: 'filter', SORT: 'sorting modified'},
    LABEL: {TRY_ON: 'try on button'},
};

export const EVENT_CATEGORY_RMA = {
    name: 'rma',
    category: 'rma',
    action: 'rma',
    label: formatString('{{label}}'),
};

export const REVIEW = {
    EVENT_CATEGORY: 'Product Review Form',
    EVENT_INPUT: 'Selected',
    EVENT_TEXTAREA: 'your Review Selected',
    EVENT_COUNTS: 'reviews count',
    EVENT_WRITE: 'write a review',
};

export const RATING = {
    EVENT_LABEL: 'Star',
    EVENT_ACTION: 'Rating Selected',
};

export const FILTERED_CATEGORY = 'FilteredCategory';

export const HOME = {
    TOP_MENU: {
        name: 'HP',
        category: 'Home - M',
        action: 'Top Menu',
        label: formatString('{{category}} category clicked'),
    },
};

export const GTM_REMOVE_FROM_CART = 'removeFromCart';

export const RISKIFIED = {
    CHECKOUT: {
        eventCategory: 'NewCheckout',
        eventAction: 'Riskified',
    },
    ERRORS: {
        eventCategory: 'NewCheckout',
        eventAction: 'error',
    },
};
